/* =====================================================
   Request a Quote — popup logic
   ---------------------------------------------------
   Wires up:
     * Any element with [data-rfq-open] -> open the popup
     * [data-rfq-close] / Esc / backdrop click -> close
     * Optional product context via data-rfq-product-* on trigger
     * Country dropdown populated from a built-in list
     * Image upload via Cloudinary unsigned upload preset
     * Google reCAPTCHA v3 token attached before submit
     * Form validation, character counter, focus trap
   ===================================================== */
(function () {
  "use strict";

  // ---------- Config (from inline JSON block in rfq-popup.liquid) ----------
  // We read it lazily because the <script> tag holding the config lives at
  // the bottom of <body> (inside the popup snippet), while THIS script loads
  // from <head>. Reading at parse time would always be empty.
  var _cfgCache = null;
  function readConfig() {
    if (_cfgCache) return _cfgCache;
    var node = document.getElementById("rfq-popup-config");
    if (!node) return {};
    try {
      _cfgCache = JSON.parse(node.textContent || "{}");
      return _cfgCache;
    } catch (e) { return {}; }
  }
  function cfgRecaptchaSiteKey()   { return readConfig().recaptchaSiteKey || ""; }
  function cfgRecaptchaMinScore()  { var v = readConfig().recaptchaMinScore; return typeof v === "number" ? v : 0.3; }
  function cfgCloudinaryCloud()    { return readConfig().cloudinaryCloudName || ""; }
  function cfgCloudinaryPreset()   { return readConfig().cloudinaryUploadPreset || ""; }
  function cfgMaxUploadBytes()     { return readConfig().maxUploadBytes || 5 * 1024 * 1024; }

  // ---------- Country list (ISO short names, alpha sorted) ----------
  var COUNTRIES = [
    "Afghanistan","Albania","Algeria","Andorra","Angola","Argentina","Armenia","Australia",
    "Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium",
    "Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei",
    "Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde",
    "Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo",
    "Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica",
    "Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea",
    "Estonia","Eswatini","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia",
    "Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti",
    "Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland",
    "Israel","Italy","Ivory Coast","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati",
    "Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein",
    "Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta",
    "Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco",
    "Mongolia","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal",
    "Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Korea","North Macedonia",
    "Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay",
    "Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda",
    "Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa",
    "San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles",
    "Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa",
    "South Korea","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland",
    "Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga",
    "Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine",
    "United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu",
    "Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"
  ];

  // ---------- Cloudinary unsigned upload ----------
  function uploadToCloudinary(file) {
    var cloud  = cfgCloudinaryCloud();
    var preset = cfgCloudinaryPreset();
    if (!cloud || cloud.indexOf("REPLACE_") === 0) {
      return Promise.reject(new Error("Cloudinary not configured yet."));
    }
    if (!preset || preset.indexOf("REPLACE_") === 0) {
      return Promise.reject(new Error("Cloudinary upload preset not configured."));
    }
    var url = "https://api.cloudinary.com/v1_1/" + encodeURIComponent(cloud) + "/auto/upload";
    var fd = new FormData();
    fd.append("file", file);
    fd.append("upload_preset", preset);
    return fetch(url, { method: "POST", body: fd }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) {
        throw new Error((e && e.error && e.error.message) || ("Upload failed (" + res.status + ")"));
      });
      return res.json();
    }).then(function (json) {
      if (!json.secure_url) throw new Error("Upload failed (no URL).");
      return json.secure_url;
    });
  }

  // ---------- DOM helpers ----------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function setProductContext(form, trigger) {
    // Product context is ONLY populated when the trigger explicitly carries
    // data-rfq-product-* attributes (i.e. the popup was opened from a real
    // product trigger — PDP button or product card). For generic header
    // triggers we deliberately leave these fields empty so they get
    // stripped before submit and the email subject stays short.
    var ctx = {
      title: trigger ? (trigger.getAttribute("data-rfq-product-title") || "") : "",
      url:   trigger ? (trigger.getAttribute("data-rfq-product-url")   || "") : "",
      sku:   trigger ? (trigger.getAttribute("data-rfq-product-sku")   || "") : "",
      img:   trigger ? (trigger.getAttribute("data-rfq-product-image") || "") : ""
    };

    $$("[data-rfq-ctx]", form).forEach(function (input) {
      var key = input.getAttribute("data-rfq-ctx");
      input.value = ctx[key] || "";
    });

    // Build a dynamic email subject: "[RFQ] <Product Title>"  or
    // "[RFQ] SKU <sku>" when only the SKU is known. Falls back to the
    // generic "[RFQ] New quote request" when neither is available
    // (e.g. header-triggered submissions with no product context).
    var subjectInput = $("[data-rfq-subject]", form);
    if (subjectInput) {
      var subj;
      if (ctx.title)    subj = "[RFQ] " + ctx.title;
      else if (ctx.sku) subj = "[RFQ] SKU " + ctx.sku;
      else              subj = "[RFQ] New quote request";
      // Trim long titles so the subject stays under typical email-client limits
      if (subj.length > 120) subj = subj.slice(0, 117) + "…";
      subjectInput.value = subj;
    }

    // Visible product summary
    var summary = $("[data-rfq-product]");
    if (!summary) return;
    if (ctx.title || ctx.sku || ctx.img) {
      summary.hidden = false;
      var titleEl = $("[data-rfq-product-title]", summary);
      var skuEl   = $("[data-rfq-product-sku]", summary);
      var imgEl   = $("[data-rfq-product-img]", summary);
      if (titleEl) titleEl.textContent = ctx.title || "";
      if (skuEl)   skuEl.textContent   = ctx.sku ? "SKU: " + ctx.sku : "";
      if (imgEl) {
        if (ctx.img) { imgEl.src = ctx.img; imgEl.alt = ctx.title || ""; imgEl.style.display = ""; }
        else imgEl.style.display = "none";
      }
    } else {
      summary.hidden = true;
    }
  }

  function populateCountries() {
    var sel = $("[data-rfq-country]");
    if (!sel || sel.dataset.populated === "1") return;
    var frag = document.createDocumentFragment();
    COUNTRIES.forEach(function (name) {
      var opt = document.createElement("option");
      opt.value = name;
      opt.textContent = name;
      frag.appendChild(opt);
    });
    sel.appendChild(frag);
    sel.dataset.populated = "1";
  }

  // ---------- Focus trap ----------
  var lastFocus = null;
  function trapFocus(container, e) {
    var focusables = $$(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last  = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ---------- Open / close ----------
  function openPopup(trigger) {
    var popup = $("#rfq-popup");
    if (!popup) return;
    populateCountries();
    var form = $("#rfq-form", popup);
    if (form) setProductContext(form, trigger);
    lastFocus = document.activeElement;
    popup.hidden = false;
    popup.setAttribute("aria-hidden", "false");
    document.body.classList.add("rfq-popup-open");
    // Move focus to the first real input
    setTimeout(function () {
      var firstInput = $("#rfq-name", popup) || $("input,select,textarea", popup);
      if (firstInput) firstInput.focus();
    }, 30);
  }

  function closePopup() {
    var popup = $("#rfq-popup");
    if (!popup) return;
    popup.hidden = true;
    popup.setAttribute("aria-hidden", "true");
    document.body.classList.remove("rfq-popup-open");
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
  }

  // ---------- Wire global delegated handlers ----------
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-rfq-open]");
    if (opener) {
      e.preventDefault();
      openPopup(opener);
      return;
    }
    var closer = e.target.closest("[data-rfq-close]");
    if (closer && closer.closest("#rfq-popup")) {
      e.preventDefault();
      closePopup();
    }
  });

  /* =========================================================
     Intercept the legacy RFQ buttons rendered by the
     Globo RFQ Pro and Sealapps Easy Quote apps so that EVERY
     "Request a quote" button across the site — PDP, collection
     cards, home page cards, search results — opens THIS popup
     with the correct product context auto-filled.

     We attach in the *capture* phase so we run before the apps
     get to handle the click, and we stopImmediatePropagation()
     so their listeners don't fire at all.
     ========================================================= */
  var LEGACY_RFQ_SELECTORS = [
    ".rfq-btn",
    ".rfq-collection-btn",
    "[id^='rfq-btn']",
    "[id^='rfq-collection-btn']",
    ".btn-rfq",
    ".add-to-quote",
    ".btn.add-to-quote",
    "button[data-rfq]",
    ".easy-quote-button",
    "#product-restore-quote button",
    "#product-restore-quote",
    ".grfq-quote-widget-btn",
    ".grfq-product-quote-btn"
  ].join(",");

  function textOf(el) {
    return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : "";
  }

  function findProductContext(triggerEl) {
    // If the trigger already carries data-rfq-product-* attributes
    // (e.g. our own theme buttons), use them as-is.
    if (triggerEl && triggerEl.getAttribute("data-rfq-product-title")) {
      return triggerEl;
    }

    // On a Shopify product page <body> has class "template-product".
    if (document.body.classList.contains("template-product") &&
        !triggerEl.closest(".product-card, product-card, .search-resutls_item, .related-products .product-item")) {
      // Build context from the live PDP DOM (title + URL + best-effort SKU)
      var titleEl = document.querySelector(".product-details_title") ||
                    document.querySelector(".product-info_title h1") ||
                    document.querySelector("h1.product-title");
      var skuEl   = document.querySelector(".product-details_sku, .search-resutls_item-sku, [class*='sku']");
      var imgEl   = document.querySelector(".product-media_main .zoom-image, .product-media img, .product-info_media img");
      var ctx = document.createElement("span");
      ctx.setAttribute("data-rfq-product-title", titleEl ? textOf(titleEl) : document.title);
      ctx.setAttribute("data-rfq-product-url",   window.location.href);
      ctx.setAttribute("data-rfq-product-sku",   skuEl ? textOf(skuEl).replace(/^SKU:\s*/i, "") : "");
      ctx.setAttribute("data-rfq-product-image", imgEl ? (imgEl.currentSrc || imgEl.src || "") : "");
      return ctx;
    }

    // Otherwise we are inside (or near) a product card on a listing page.
    var card = triggerEl.closest(
      "product-card, .product-card, .search-resutls_item, .product-item, .single-product-item, .product-owl-item"
    );
    if (!card) {
      // Last fallback: walk up looking for an anchor we can use
      var anchor = triggerEl.closest("a[href*='/products/']");
      if (anchor) {
        var fallback = document.createElement("span");
        fallback.setAttribute("data-rfq-product-title", textOf(anchor));
        fallback.setAttribute("data-rfq-product-url",   anchor.href);
        fallback.setAttribute("data-rfq-product-sku",   "");
        fallback.setAttribute("data-rfq-product-image", "");
        return fallback;
      }
      return null;
    }

    var titleA = card.querySelector(".product-card_title a, .product-title a, .product-card_vendor-title a, .search-resutls_item-title");
    var img    = card.querySelector(".product-card_media img, .product-item_image img, img");
    var skuA   = card.querySelector(".search-resutls_item-sku, .product-card_sku, [class*='sku']");
    var hrefEl = card.querySelector("a[href*='/products/']");

    var span = document.createElement("span");
    span.setAttribute("data-rfq-product-title", titleA ? textOf(titleA) : "");
    span.setAttribute("data-rfq-product-url",   hrefEl ? hrefEl.href : (titleA && titleA.href ? titleA.href : ""));
    span.setAttribute("data-rfq-product-sku",   skuA ? textOf(skuA).replace(/^SKU:\s*/i, "") : "");
    span.setAttribute("data-rfq-product-image", img ? (img.currentSrc || img.src || img.getAttribute("data-src") || "") : "");
    return span;
  }

  document.addEventListener("click", function (e) {
    var legacy = e.target.closest(LEGACY_RFQ_SELECTORS);
    if (!legacy) return;
    // Don't double-intercept our own popup's internals
    if (legacy.closest("#rfq-popup")) return;
    // Don't intercept buttons that already opt-in to our popup
    if (legacy.hasAttribute("data-rfq-open")) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var ctx = findProductContext(legacy);
    openPopup(ctx);
  }, true); // <-- capture: true, runs before app listeners

  document.addEventListener("keydown", function (e) {
    var popup = $("#rfq-popup");
    if (!popup || popup.hidden) return;
    if (e.key === "Escape") { e.preventDefault(); closePopup(); return; }
    if (e.key === "Tab") { trapFocus(popup, e); }
  });

  // ---------- Form behaviour ----------
  document.addEventListener("DOMContentLoaded", function () {
    var form = $("#rfq-form");
    if (!form) return;

    // Character counter on details
    var details = $("#rfq-details", form);
    var counter = $("[data-rfq-charcount]", form);
    if (details && counter) {
      var updateCount = function () { counter.textContent = String(details.value.length); };
      details.addEventListener("input", updateCount);
      updateCount();
    }

    // File upload handler
    var fileInput = $("[data-rfq-file]", form);
    var fileStatus = $("[data-rfq-file-status]", form);
    var attachmentUrlInput = $("[data-rfq-attachment-url]", form);
    if (fileInput) {
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        if (!file) {
          if (attachmentUrlInput) attachmentUrlInput.value = "";
          if (fileStatus) { fileStatus.textContent = ""; fileStatus.className = "rfq-form__file-status"; }
          return;
        }
        if (file.size > cfgMaxUploadBytes()) {
          fileInput.value = "";
          if (attachmentUrlInput) attachmentUrlInput.value = "";
          if (fileStatus) { fileStatus.textContent = "File is too large. Max 5 MB."; fileStatus.className = "rfq-form__file-status is-error"; }
          return;
        }
        if (fileStatus) { fileStatus.textContent = "Uploading…"; fileStatus.className = "rfq-form__file-status"; }
        uploadToCloudinary(file).then(function (url) {
          if (attachmentUrlInput) attachmentUrlInput.value = url;
          if (fileStatus) { fileStatus.textContent = "Image attached."; fileStatus.className = "rfq-form__file-status is-ok"; }
        }).catch(function (err) {
          if (attachmentUrlInput) attachmentUrlInput.value = "";
          if (fileStatus) { fileStatus.textContent = (err && err.message) || "Upload failed."; fileStatus.className = "rfq-form__file-status is-error"; }
          fileInput.value = "";
        });
      });
    }

    // Field-level validation (also runs on submit)
    function validateField(field) {
      var ok = field.checkValidity();
      field.setAttribute("aria-invalid", ok ? "false" : "true");
      return ok;
    }
    $$("input,select,textarea", form).forEach(function (f) {
      f.addEventListener("blur", function () { validateField(f); });
    });

    // Format a Date as e.g. "16 May 2026, 10:32 AM (GMT+5:30)"
    function formatSubmittedAt(d) {
      try {
        var datePart = d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
        var timePart = d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: true });
        var offsetMin = -d.getTimezoneOffset();
        var sign = offsetMin >= 0 ? "+" : "-";
        var abs = Math.abs(offsetMin);
        var tz = "GMT" + sign + String(Math.floor(abs / 60)).padStart(2, "0") + ":" + String(abs % 60).padStart(2, "0");
        return datePart + ", " + timePart + " (" + tz + ")";
      } catch (e) {
        return d.toString();
      }
    }

    function stampSubmittedAt() {
      var stamp = $("[data-rfq-submitted-at]", form);
      if (stamp) stamp.value = formatSubmittedAt(new Date());
    }

    function dropEmptyFields() {
      // Remove any hidden input marked data-rfq-drop-if-empty whose value
      // is blank, so the inquiry email never shows an empty row.
      $$("[data-rfq-drop-if-empty]", form).forEach(function (input) {
        if (!input.value) input.parentNode && input.parentNode.removeChild(input);
      });
    }

    // Submit handler — validate, stamp the date, drop empty fields,
    // then let the browser submit the native Shopify {% form 'contact' %}.
    form.addEventListener("submit", function (e) {
      var allValid = true;
      $$("input[required], select[required], textarea[required]", form).forEach(function (f) {
        if (!validateField(f)) allValid = false;
      });
      if (!allValid) {
        e.preventDefault();
        var firstBad = $('[aria-invalid="true"]', form);
        if (firstBad) firstBad.focus();
        return;
      }
      stampSubmittedAt();
      dropEmptyFields();
    });

    // If we landed back after a successful Shopify contact form submission,
    // re-open the popup so the customer sees the thank-you state.
    if (form.querySelector(".rfq-form__success")) {
      openPopup(null);
    }
  });
})();